import { APPLICATION_STATUS_OPTIONS } from '@/constants/applications'
import { ApplicationsState } from '@/state'
import { applicationsStateActions } from '@/state/actions'
import { Select } from 'antd'

export default function ApplicationsStatusFilter() {
  return (
    <Select
      value={ApplicationsState.filters.value.status}
      className='status-filter'
      options={APPLICATION_STATUS_OPTIONS}
      allowClear
      onChange={applicationsStateActions.setApplicationStatusFilter}
      filterOption={(input, option) =>
        !!option && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      disabled={ApplicationsState.loading.value.getAll}
      placeholder='Filtro por estado'
    />
  )
}
